import { Component, OnInit } from '@angular/core';
import { ValidacionClienteService } from '../../../services/validacion-cliente.service';

@Component({
  selector: 'edicion-estado-situacion',
  templateUrl: './edicion-estado-situacion.component.html',
  styleUrls: ['./edicion-estado-situacion.component.scss']
})
export class EdicionEstadoSituacionComponent implements OnInit {
  token: string;
  id: string;

  constructor(
    private readonly validacionClienteSrv: ValidacionClienteService
  ) {}

  ngOnInit(): void {
    this.token = this.validacionClienteSrv.cifrado;
    this.id = this.validacionClienteSrv.getPreguntas().rut;
  }
}
